import React, { useEffect, useState } from "react";
import './admin.css';

function AdminPage() {
  const [applications, setApplications] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState("");
  const [jobIds, setJobIds] = useState([]);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [error, setError] = useState("");

  // Correct login credentials
  const correctUsername = "globalsgtech";
  const correctPassword = "12345678901234567890123456789012"; // 32-digit password

  useEffect(() => {
    if (isLoggedIn) {
      // Fetch job applications from the backend
      fetch("https://globalsgtech.com/api/applications")
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            const allApps = data.applications;

            const sortedJobIds = [...new Set(
              allApps
                .sort((a, b) => new Date(b.submittedAt) - new Date(a.submittedAt))
                .map(app => app.jobId)
            )];

            setApplications(allApps);
            setJobIds(sortedJobIds);
            setSelectedJobId(sortedJobIds[0] || "");
          }
        })
        .catch(err => console.error("Error fetching applications:", err));
    }
  }, [isLoggedIn]);

  const filteredApps = applications.filter(app => app.jobId === selectedJobId);
  const selectedJobTitle = applications.find(app => app.jobId === selectedJobId)?.jobTitle || "";

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === correctUsername && password === correctPassword) {
      setIsLoggedIn(true);
      setError(""); // Clear any previous errors
    } else {
      setError("Invalid username or password");
    }
  };

  const handleDownload = async (resumeKey) => {
    try {
      const encodedKey = encodeURIComponent(resumeKey);

      const res = await fetch(`https://globalsgtech.com/api/download-resume?key=${encodedKey}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = resumeKey.split("/").pop();
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
      alert("Error while downloading resume");
    }
  };

  // Combine salary and salaryType
  const getFormattedSalary = (salary, salaryType) => {
    if (salary && salaryType) {
      return `$${salary} ${salaryType}`;
    }
    return "N/A";
  };

  return (
    <div className="admin-container">
      {!isLoggedIn ? (
        // Login form if not logged in
        <div className="login-form">
          <h2>Admin Login</h2>
          <form onSubmit={handleLogin}>
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <p className="error-message">{error}</p>}
            <button type="submit">Login</button>
          </form>
        </div>
      ) : (
        // Admin table if logged in
        <div>
          <h2>Admin – Job Applications</h2>

          <div className="job-selection">
            <label>Select Job ID:</label>
            <select 
              value={selectedJobId} 
              onChange={e => setSelectedJobId(e.target.value)}
            >
              {jobIds.map(id => (
                <option key={id} value={id}>{id}</option>
              ))}
            </select>

            <span className="job-title">
              Job Name: {selectedJobTitle}
            </span>
          </div>

          <table className="admin-table">
            <thead>
              <tr>
                <th>Applicant Name</th>
                <th>Visa Type</th>
                <th>Email</th>
                <th>Phone</th>
                <th>ZIP Code</th> {/* Added */}
                <th>Applied At</th>
                <th>Employment Type</th>
                <th>Salary</th>
                <th>Resume</th>
              </tr>
            </thead>
            <tbody>
              {filteredApps.map((app, i) => (
                <tr key={i}>
                  <td>{app.fullName}</td>
                  <td>{app.visaType}</td>
                  <td>{app.email}</td>
                  <td>{app.contact}</td>
                  <td>{app.zipCode || "N/A"}</td> {/* Added */}
                  <td>{new Date(app.submittedAt).toLocaleString()}</td>
                  <td>{app.employmentType || "N/A"}</td>
                  <td>{getFormattedSalary(app.salary, app.salaryType)}</td> {/* Combine salary and salary type */}
                  <td>
                    {app.resumeS3Key ? (
                      <button onClick={() => handleDownload(app.resumeS3Key)}>
                        Download Resume
                      </button>
                    ) : (
                      "No Resume"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminPage;
